import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, IconButton, Menu, MenuItem, Avatar, Divider } from '@mui/material';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

export default function UserMenu({ userData, onLogout }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    onLogout();
  };

  if (!userData) return null;

  return (
    <>
      <IconButton size="small" onClick={handleMenuOpen} sx={{ maxWidth: '32px', maxHeight: '32px', borderRadius: '50%' }}>
        <Avatar
          src={userData?.photoURL}
          alt={userData?.displayName || userData?.email}
          sx={{
            maxWidth: '32px',
            maxHeight: '32px',
            bgcolor: 'primary.main',
            fontSize: '0.875rem',
            fontWeight: 500
          }}
        >
          {userData?.displayName ? userData.displayName.substring(0, 2).toUpperCase() : userData?.email.substring(0, 2).toUpperCase()}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar src={userData?.photoURL} alt={userData?.displayName || userData?.email} sx={{ borderRadius: '50%' }} />
            <Box sx={{ ml: 1.5 }}>
              <Typography variant="subtitle1">{userData?.displayName || ''}</Typography>
              <Typography variant="body2" color="text.secondary">
                {userData?.email || ''}
              </Typography>
            </Box>
          </Box>
        </MenuItem>
        <Divider />
        <MenuItem component={Link} to="/profile">
          <Person2RoundedIcon sx={{ mr: 1 }} />
          Profile
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <LogoutRoundedIcon sx={{ mr: 1 }} />
          Log out
        </MenuItem>
      </Menu>
    </>
  );
}
